import { IconFlagPK } from './icons';

export default function Footer() {
  return (
    <footer className="foot">
      <div className="foot-inner">

        {/* Big statement CTA */}
        <div className="foot-statement">
          <p className="foot-eyebrow">Ready to modernise?</p>
          <a href="#cta" className="foot-cta-link display">
            Request&nbsp;Access
            <span className="foot-arrow">↗</span>
          </a>
        </div>

        {/* Divider */}
        <div className="foot-rule" />

        {/* Brand + Nav row */}
        <div className="foot-grid">
          <div className="foot-brand">
            <span className="foot-logo display">Plateera.</span>
            <p>The operating system<br />for modern restaurants.</p>
          </div>

          <nav className="foot-nav">
            <div className="foot-nav-col">
              <span className="foot-nav-head">Product</span>
              <a href="#walk">Console</a>
              <a href="#tableord">QR Ordering</a>
              <a href="#mobile">Guest App</a>
              <a href="#hotel">Hospitality</a>
              <a href="#features">Features</a>
              <a href="#how">How it works</a>
              <a href="#ai">Intelligence</a>
            </div>
            <div className="foot-nav-col">
              <span className="foot-nav-head">Company</span>
              <a href="#cta">Get Access</a>
              <a href="#">About</a>
              <a href="#">Careers</a>
              <a href="mailto:contact@plateera.com">Contact</a>
            </div>
          </nav>
        </div>

        {/* Bottom bar */}
        <div className="foot-bar">
          <span>© 2026 Plateera. All rights reserved.</span>
          <span className="foot-origin">
            Made in Pakistan <IconFlagPK className="foot-flag" />
          </span>
        </div>

      </div>
    </footer>
  );
}
